import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { USER_API_URL } from "../../../config";

export interface IDeleteUserMutation {
  user_id: string;
}

export const useDeleteUser = () => {
  return useMutation({
    mutationFn: (props: IDeleteUserMutation) =>
      axios
        .delete(
          `${USER_API_URL}/waves-user-manager-api/v1/users/${props.user_id}`,
          {}
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
